const getIllustration = ({ size, large, medium, small }) => {
  if (large && (size >= 512 || !medium && !small)) {
    return large;
  }
  if (medium && (size >= 201 || !small)) {
    return medium;
  }
  return small;
};
export {
  getIllustration as g
};
//# sourceMappingURL=utils.js.map
